import {
	FETCH_LICENSESTATS
} from "../actions/types";

export default (state = {}, action) => {
	switch (action.type) {
		
		case FETCH_LICENSESTATS:
			return {
				...state,
				...action.payload
			}
		default:
			return state;
	}
}